import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, debounceTime, distinctUntilChanged, tap } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SpinnerService {

  progressRatioSubject = new BehaviorSubject<number>(0);
  progressSource$ = this.progressRatioSubject.asObservable();
  totalRequests = 0;
  completedRequests = 0;


  // busyRequestCount = 0;
  // isLodaing = new BehaviorSubject<boolean>(false);
  // isloading$ = this.isLodaing.asObservable().pipe(tap(isLodaing => console.log("**isLodaing**", isLodaing)));
  // constructor(private spinner: NgxSpinnerService) { }
  // busy() {
  //   if (this.busyRequestCount == 0) {
  //     this.isLodaing.next(true);
  //   }
  //   this.busyRequestCount++;
  //   this.spinner.show();
  // }
  // idle() {

  //   this.busyRequestCount--;
  //   if (this.busyRequestCount <= 0) {
  //     this.busyRequestCount = 0;
  //     this.spinner.hide();
  //     this.isLodaing.next(false);
  //   }
  // }

  startRequest() {
    this.totalRequests++;
    this.updateProgress();
  }

  completeRequest() {
    this.completedRequests++;
    this.updateProgress();
  }
  private updateProgress() {
    const progressRatio = this.totalRequests === 0 ? 0 : this.completedRequests / this.totalRequests;
    if (progressRatio == 1) {
      this.totalRequests = 0;
      this.completedRequests = 0;

    }
    this.progressRatioSubject.next(progressRatio);
  }












}
